import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * 共通フッター — 全ページの末尾に配置
 *
 * 旧来は LandingPage.js にインラインでのみ存在し、 規約・プライバシー・特商法等の
 * 法的文書ページには表示されていなかった (= ユーザーから問題報告 2026-05-08)。
 * 共通コンポーネント化して、 Header を使う全ページに配置する。
 */
const Footer = () => (
  <Box sx={{ py: 4, px: 3, mt: 6, borderTop: '1px solid', borderColor: 'divider' }}>
    <Container maxWidth="lg">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
        <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
          &copy; {new Date().getFullYear()} Penlytics
        </Typography>
        <Box sx={{ display: 'flex', gap: 3 }}>
          {[
            { to: '/guide', label: '使い方ガイド' },
            { to: '/terms', label: '利用規約' },
            { to: '/privacy', label: 'プライバシー' },
            { to: '/legal', label: '特商法表記' },
          ].map(link => (
            <Typography
              key={link.to}
              component={RouterLink}
              to={link.to}
              sx={{ fontSize: '13px', color: 'text.secondary', textDecoration: 'none', '&:hover': { color: 'text.primary' } }}
            >
              {link.label}
            </Typography>
          ))}
        </Box>
      </Box>
    </Container>
  </Box>
);

export default Footer;
